module.exports = __webpack_public_path__ + "img/tr.982fd3ef.png";